import { INSURERS } from "@/constants/site";

export const InsurerStrip = () => (
  <section
    data-testid="insurer-strip"
    className="border-b border-brand-ink/10 bg-white py-5 sm:py-6"
  >
    <div className="mx-auto flex max-w-7xl flex-col items-center gap-4 px-4 sm:px-8 lg:flex-row lg:flex-nowrap lg:gap-4 xl:gap-6">
      <p className="max-w-xs text-center text-[13px] leading-snug text-gray-600 sm:max-w-md sm:text-sm lg:max-w-none lg:whitespace-nowrap lg:text-left lg:[font-size:clamp(10px,0.92vw,12.5px)]">
        Contamos con las{" "}
        <span className="font-semibold text-brand-ink">
          mejores condiciones del mercado industrial
        </span>
        , con el respaldo de:
      </p>
      <div className="flex flex-1 flex-wrap items-center justify-center gap-x-6 gap-y-4 sm:gap-x-6 sm:gap-y-5 lg:flex-nowrap lg:justify-end lg:gap-x-4 xl:gap-x-6">
        {INSURERS.map((i) => (
          <img
            key={i.id}
            data-testid={`insurer-logo-${i.id}`}
            src={i.logo}
            alt={i.name}
            style={{ "--logo-h": `${i.h}px` }}
            className="h-[calc(var(--logo-h)*0.72)] w-auto opacity-80 transition-opacity duration-300 hover:opacity-100 sm:h-[calc(var(--logo-h)*0.8)] lg:h-[calc(var(--logo-h)*0.62)] xl:h-[calc(var(--logo-h)*0.75)]"
            loading="lazy"
          />
        ))}
      </div>
    </div>
  </section>
);
